import { Stack, Text } from "@mantine/core";
import { ConfirmAndExecutePanel, EntityClientAction, FakeProgressBar } from "@mcurros2/microm";
import { Personal } from "./Personal";
import { PersonalJerarquia } from "./PersonalJerarquia/PersonalJerarquia";

export const ACTEliminarPersonal: EntityClientAction = {
    name: 'ACTEliminarPersonal',
    label: 'Eliminar Personal',
    title: <Text fw={700}>Eliminar Personal</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: ['perl_brwGestionPersonalDetalles'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        const abort_controller = new AbortController();

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const parent = entity as Personal;

        await modal.open({
            modalProps: {
                title: <Text fw="700">{`Quitar relación ${parent.Title}`}</Text>,
            },
            focusOnClosed: element,
            content:
                <ConfirmAndExecutePanel
                    operation="edit"
                    loadingContent={
                        <Stack>
                            <FakeProgressBar />
                            <Text size="sm" mb="xs">{`Eliminando relaciones`}</Text>
                        </Stack>
                    }
                    content={<Text size="sm" mb="xs">Jerarquía de personal</Text>}
                    okButtonText="Aceptar"
                    onCancel={async () => {
                        await abort_controller.abort();
                        await modal.close();
                        if (onClose) await onClose();
                    }}
                    onOK={async () => {

                        const personaljerarquia = new PersonalJerarquia(parent.API.client);

                        const result = await personaljerarquia.API.deleteData(selectedKeys, abort_controller.signal);
                      
                        if (!result.Failed) {
                            if (onClose) await onClose();
                            await modal.close();
                        }
                    }}
                />
        });

        return false;
    }
}